import React from 'react'

import { Modal, Button } from '_zari/core'

import * as Sections from './sections'

const HistorialComprasModal = ({ handleClose, show, history, mainFormData, submitFunction }) => {
  const [documentoInfo, setDocumentoInfo] = React.useState(null)

  const clickSeleccionarDocumentoClick = React.useCallback(row => {
    setDocumentoInfo(row)
  }, [])

  const handleSubmit = React.useCallback(() => {
    mainFormData._idDocumentoRelacionado = documentoInfo._id

    submitFunction(mainFormData)
  }, [mainFormData, documentoInfo, submitFunction])

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>CONSULTAR DOCUMENTO</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {documentoInfo ? (
          <Sections.DocumentoInfoSection documentoInfo={documentoInfo} />
        ) : (
          <Sections.ListaDocumentosSection idSocio={mainFormData._idSocio} clickSeleccionarDocumentoClick={clickSeleccionarDocumentoClick} />
        )}
      </Modal.Body>
      {documentoInfo && (
        <Modal.Footer>
          <Button color='secondary' onClick={handleClose}>
            Cancelar
          </Button>
          <Button onClick={handleSubmit}>Procesar</Button>
        </Modal.Footer>
      )}
    </Modal>
  )
}

export default React.memo(HistorialComprasModal)
